import Tabs from "antd/lib/tabs";

export default Tabs;
